/**
 * Returns a number whose value is limited to the given range.
 */
export const clamp = (value: number, min: number, max: number) =>
    Math.min(Math.max(value, min), max);

/**
 * Returns a percentage based on pixels value
 */
export const getPercentageValue = (value: number, divider: number): number =>
    (value / divider) * 100;

/**
 * Returns a px value from percentage value
 */
export const getPixelValue = (value: number, divider: number): number =>
    (value / 100 || 0) * divider;

/**
 * Returns a number rounded with 2 digits ie. 1.008 => 1.01
 */
export const roundToTwo = (num: number): number => {
    return Math.round(num * 1e2) / 1e2;
};

/**
 * (very) SudoRandom number generator that can be consistent based off a seed.
 * @param seed
 */
export const seededRandom = (seed: number) => {
    const x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
};
